export default __webpack_public_path__ + "static/media/kds.e81f3c02.jpg";